module.exports = __webpack_public_path__ + "static/media/miami-21.f4a9eda5.jpg";